import { EntityStatus, Sensor, Transceiver, Vat } from '@/api';
import { VatSensorTypes } from '@/pages/account/products/milk/vats/models/vat-sensor-type';
import { EntityStatusService } from './entity-status-service';

export class MilkVatStatusService extends EntityStatusService<
	Vat & { transceiver: Transceiver; sensors: Sensor[] }
> {
	public entityReadyForSignOff(): boolean {
		if (
			this.entity.status === EntityStatus.Install &&
			this.vatIsProvisioned &&
			this.hardwareAllocated
		) {
			return true;
		}
		return false;
	}

	public get vatIsProvisioned(): boolean {
		const provisionAttributes = [
			this.entity.state,
			this.entity.formula,
			this.entity.sizeString,
			this.entity.vatOffset,
			this.entity.emptyDistance,
		];
		return !(provisionAttributes.includes(null) || provisionAttributes.includes(undefined));
	}

	private get hardwareAllocated(): boolean {
		const allocatedSensorTypes = this.entity.sensors.map((sensor: Sensor) => sensor.type);
		const sensorsAllocated = [
			VatSensorTypes.INLET_TEMP,
			VatSensorTypes.LIDAR,
			VatSensorTypes.STIRRER,
			VatSensorTypes.VAT_TEMP,
		].every((sensorType: VatSensorTypes) => allocatedSensorTypes.includes(sensorType));
		if (this.entity.transceiver?.id && sensorsAllocated && this.entity.sensors.length === 4) {
			return true;
		}
		return false;
	}
}
